import "esbuild-css-modules-plugin-ns-css:components/chat-widget.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:components/chat-widget.module.css:injector.js";
export default new Proxy({
  "closeButton": "chat-widget-module__closeButton__n6L7q__010",
  "closeIcon": "chat-widget-module__closeIcon__n6L7q__010",
  "launcher": "chat-widget-module__launcher__n6L7q__010",
  "launcherIcon": "chat-widget-module__launcherIcon__n6L7q__010",
  "panel": "chat-widget-module__panel__n6L7q__010",
  "panelBody": "chat-widget-module__panelBody__n6L7q__010",
  "panelHidden": "chat-widget-module__panelHidden__n6L7q__010",
  "widget": "chat-widget-module__widget__n6L7q__010"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      